
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-home-line',
      title: 'Residential Area',
      description: 'Professional home cleaning services with flexible packages to meet your specific needs and budget.',
      features: ['Basic package', 'Standard package', 'Premium package', 'Houses (depends on size square footage/bedrooms, bathrooms)', 'General clean package', 'Deep clean package'],
      pricing: 'Rough estimates: 1,500-1,800 sq ft & 2,000sqft +',
      image: 'https://public.readdy.ai/ai/img_res/1f956ebf3e2f390eebeff5edc8654377.jpg'
    },
    {
      icon: 'ri-building-line',
      title: 'Apartment Complex',
      description: 'Comprehensive cleaning solutions for apartment complexes and residential properties.',
      features: ['Turnover cleanings for vacant units', 'Common area maintenance (lobbies, hallways, gyms)', 'Move-in/move-out deep cleans', 'Scheduled cleanings tailored to your property\'s needs'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20complex%20lobby%20being%20professionally%20cleaned%2C%20elegant%20entrance%20with%20marble%20floors%2C%20contemporary%20furniture%2C%20cleaning%20staff%20working%20efficiently%2C%20bright%20natural%20lighting%2C%20spotless%20common%20areas%2C%20professional%20maintenance%20service%2C%20upscale%20residential%20building%20interior&width=600&height=400&seq=apartment-complex&orientation=landscape'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Offices',
      description: 'Professional office cleaning services to maintain a productive and healthy work environment.',
      features: ['Daily or scheduled general office cleaning', 'Common area and lobby cleaning', 'Restroom sanitation and restocking', 'Trash removal and recycling', 'Kitchen and breakroom cleaning', 'Floor care (vacuuming, mopping, waxing)', 'Glass, mirror, and partition cleaning', 'After-hours or custom scheduling'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20modern%20office%20space%20being%20cleaned%2C%20sleek%20conference%20rooms%20with%20glass%20walls%2C%20contemporary%20workstations%2C%20cleaning%20equipment%20visible%2C%20bright%20fluorescent%20lighting%2C%20organized%20workspace%2C%20clean%20carpets%20and%20surfaces%2C%20business%20environment%20with%20warm%20accents&width=600&height=400&seq=office-cleaning&orientation=landscape'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Gym',
      description: 'Specialized fitness facility cleaning with focus on hygiene and equipment sanitization.',
      features: ['Equipment and surface disinfection', 'Locker room and restroom cleaning', 'Floor care (mop, vacuum, deep clean)', 'Trash removal and odor control', 'Mirror, window, and reception area cleaning', 'After-hours or off-peak scheduling available'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20fitness%20gym%20being%20professionally%20cleaned%2C%20exercise%20equipment%20being%20sanitized%2C%20bright%20workout%20area%20with%20mirrors%2C%20cleaning%20staff%20disinfecting%20surfaces%2C%20spotless%20locker%20rooms%2C%20professional%20gym%20maintenance%2C%20health%20and%20safety%20focused%20cleaning&width=600&height=400&seq=gym-cleaning&orientation=landscape'
    },
    {
      icon: 'ri-bear-smile-line',
      title: 'Daycare',
      description: 'Child-safe cleaning and sanitization services for daycare centers and educational facilities.',
      features: ['Daily cleaning and sanitizing of classrooms and play areas', 'Restroom cleaning and disinfection', 'Carpet and floor care (vacuuming, mopping, stripping, waxing, buffing)', 'Disinfection of high-touch surfaces (toys, doorknobs, light switches)', 'Trash removal and diaper disposal coordination', 'Window and glass cleaning', 'After-hours or weekend cleaning'],
      image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20daycare%20classroom%20being%20professionally%20cleaned%2C%20children%5Cs%20play%20area%20with%20educational%20toys%2C%20small%20tables%20and%20chairs%2C%20cleaning%20staff%20sanitizing%20surfaces%2C%20safe%20child-friendly%20environment%2C%20natural%20lighting%2C%20spotless%20and%20organized%20space&width=600&height=400&seq=daycare-cleaning&orientation=landscape'
    },
    {
      icon: 'ri-community-line',
      title: 'Church',
      description: 'Respectful and thorough cleaning services for places of worship and community gatherings.',
      features: ['Sanctuary and fellowship hall cleaning', 'Restroom sanitization', 'Floor care (vacuuming, mopping, stripping, waxing, buffing)', 'Window and glass cleaning', 'Post-event and special service cleanup', 'Disinfection of high-touch surfaces (per CDC guidelines)', 'Flexible scheduling around worship and events'],
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20church%20sanctuary%20being%20professionally%20cleaned%2C%20wooden%20pews%20and%20altar%20area%2C%20stained%20glass%20windows%2C%20peaceful%20worship%20space%2C%20cleaning%20staff%20working%20respectfully%2C%20pristine%20floors%20and%20surfaces%2C%20spiritual%20atmosphere%20with%20warm%20lighting&width=600&height=400&seq=church-cleaning&orientation=landscape'
    }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-orange-50 to-peach-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Cleaning Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From residential homes to places of worship, we provide comprehensive cleaning solutions 
            tailored to your specific needs and schedule.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 bg-cover bg-center bg-top" style={{ backgroundImage: `url(${service.image})` }}></div>
              <div className="p-6">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-orange-500 text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4 text-sm">{service.description}</p>
                {service.pricing && (
                  <div className="bg-orange-50 rounded-lg p-3 mb-4">
                    <p className="text-orange-700 text-sm font-medium">{service.pricing}</p>
                  </div>
                )}
                <ul className="space-y-1 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start text-gray-700 text-sm">
                      <i className="ri-check-line text-orange-500 mr-2 mt-0.5 flex-shrink-0"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <Button variant="outline" className="w-full" onClick={() => scrollToSection('quote')}>
                  Get Quote
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <Button size="lg" onClick={() => scrollToSection('quote')}>
            <i className="ri-phone-line mr-2"></i>
            Schedule Your Cleaning Today
          </Button>
        </div>
      </div>
    </section>
  );
}